import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Loader2, Save, ExternalLink, ClipboardCheck, SkipForward } from 'lucide-react';

export default function StepMaturity({ orgId, state, onSave, saving, shareToken }) {
  const [draft, setDraft] = useState(state.answers || {});
  const navigate = useNavigate();
  useEffect(() => { setDraft(state.answers || {}); }, [state]);

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-5 space-y-4" data-testid="onboarding-step-maturity">
      <div className="rounded-lg border border-indigo-200 bg-indigo-50/40 p-4">
        <div className="flex items-start gap-3">
          <ClipboardCheck className="h-5 w-5 text-indigo-600 shrink-0 mt-0.5" />
          <div className="text-sm text-indigo-900 space-y-2">
            <p>
              The 30-dimension diagnostic across 5 pillars — Demand, Skills, Governance, Insight, Adoption.
              Takes about 20 minutes. We capture your overall score + per-pillar scores back into onboarding
              automatically when you submit.
            </p>
            <p className="text-xs text-indigo-700">
              Already done? Paste the assessment id below. Want to skip for now? Tick "skip" and move on —
              you can complete it any time from <strong>Administration → Maturity</strong>.
            </p>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        {!shareToken && (
          <Button
            onClick={() => navigate('/admin/maturity')}
            variant="outline"
            data-testid="onb-maturity-launch-btn"
          >
            <ExternalLink className="h-3.5 w-3.5 mr-2" />
            Open Maturity Assessment
          </Button>
        )}
        <label className="inline-flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!draft.skipped}
            onChange={(e) => setDraft({ ...draft, skipped: e.target.checked })}
            data-testid="onb-maturity-skip"
          />
          Skip for now
        </label>
      </div>

      {draft.skipped && (
        <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded px-3 py-2">
          <SkipForward className="inline h-3 w-3 mr-1" />
          Skipped maturity assessment — this won't block activation but you'll see "Incomplete onboarding" hints
          across Mission Control until you complete it.
        </p>
      )}

      <div className="flex justify-end pt-2">
        <Button onClick={() => onSave(draft)} disabled={saving} data-testid="onb-maturity-save">
          {saving ? <Loader2 className="h-3.5 w-3.5 mr-2 animate-spin" /> : <Save className="h-3.5 w-3.5 mr-2" />}
          Save & continue
        </Button>
      </div>
    </div>
  );
}
